import axios from 'axios'
import countries from './countries'
import { getItemLocalStorage } from './helper.utils'
import request from '@utils/requests'
import endpoints from '@constants/endpoints.json'
import useAuthStore from '@store/auth.store.js'
import { getSentryService } from '@/services/sentryService'

const institution = import.meta.env.VITE_INSTITUATION || 'kenya'
const country = countries[institution]
const baseUrl = import.meta.env.VITE_BASE_URL
const organization = JSON.parse(
  JSON.stringify(endpoints[`${import.meta.env.VITE_BRAND}`]),
)

async function makeRequest(
  endpoint,
  method = 'GET',
  data = {},
  params,
  headers,
) {
  const sentryLogger = getSentryService()
  const accountData = getItemLocalStorage('accountData') || {}

  const respbody = {
    INSTID: country.id || 'RUBISKE',
    ...data,
    ...(accountData?.USERNAME ? { USERNAME: accountData.USERNAME } : {}),
  }

  const body = data
    ? {
      respbody,
    }
    : {}

  const getEndpoint = (endpoint) => {
    try {
      const parseEndpoint = organization.endpoints[`${endpoint}`].toString()

      if (parseEndpoint) {
        return parseEndpoint
      } else {
        throw endpoint
      }
    } catch (error) {
      return error
    }
  }

  const url = `${baseUrl}${getEndpoint(endpoint)}`

  try {
    const response = await request({
      url,
      method,
      headers,
      data: body,
      params,
    })

    if (response.data?.respcode === 5 || response.data?.respcode === 5) {
      const { getToken } = useAuthStore()
      token = await getToken()
      headers.Authorization = `Bearer ${token}`
      return makeRequest(endpoint, method, data, params, headers)
    }

    if (response.data?.respcode !== 0 && !url.includes('authenticate')) {
      sentryLogger.instance.captureMessage(
        response.data?.respmsg || 'Error from the API',
        'error',
      )
    } else if (url.includes('authenticate')) {
      // console.log(response, 'authenticate')

      sentryLogger.instance.addBreadcrumb(
        response.data?.token || 'Error from the authenticate API',
        'info',
      )
    }

    return response.data
  } catch (error) {
    sentryLogger?.logError(error, {
      action: 'making API Request',
      handled: true,
      component: 'api-service.utils.js',
    })

    throw error
  }
}

export default makeRequest
